<template>
  <div class="home">
        <div style="width:100%;background: #f5f6fa;">
          <div class="classify_scroll" >
              <el-row>
                <!-- <el-col :span="4"><div class="grid-content ep-bg-purple" />
                  <div class="pull-down" @mouseleave="selectItems()">
                    <div class="pull_left" style="box-shadow: 0 2px 12px #0000001a;height:430px">
                      <div v-for="(o,index) in category" :key="index" @mouseenter="selectItem(index)"  :class="{'active':selectNumber === index}" class="pull_item" style="padding: 12px 8px;">{{ o.tree_alias }}</div>
                    </div>
                    <div class="pull-right" v-if="subCategory.length>0">
                      <div class="pull_list clearfix" v-for="item in subCategory" :key="item">
                        <label style="color:#0066BA">{{ item.tree_name  }}</label>
                        <div v-if="item.sub_category">
                          <span @click="goClassify(i.tree_id)" v-for="(i) in item.sub_category" :key="i.tree_id">{{ i.tree_name }}</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </el-col> -->
                <!-- <el-col :span="24"><div class="grid-content ep-bg-purple" /> 
                  <el-carousel height="450px" v-if="bannerList.length>0">
                    <el-carousel-item v-for="item in bannerList" :key="item">
                      <el-image style="height: 500px;width:100%;cursor: pointer;"   :src="item.up_img"  @click="goBanner(item)" />
                    </el-carousel-item>
                  </el-carousel>
                </el-col> -->
                <el-col :xs="24" :sm="24" :md="24">
                <div class="block indexBanner" :style="{ height: bannerHeight + 'px' }">
                  <el-carousel :height="bannerHeight + 'px'" id="el-carousel">
                    <template #default>
                      <el-carousel-item v-for="(item, index) in bannerList" :key="index">
                        <a :href="item.banner_link" target="_blank">
                          <img ref="bannerImgRef"  @error="handleErrorImage"  @load="screenSize" class="indexBannerImg" :src="item.up_img" alt="">
                        </a>
                      </el-carousel-item>
                    </template>
                  </el-carousel>
                </div>
              </el-col> 
               <!--  <el-col :span="4"><div class="grid-content ep-bg-purple" />
                  <el-card class="box-card">
                    <div style="display: flex;">
                      <el-avatar :size="50"/>
                      <div style="margin-left:5px">
                        <span style="font-size:14px;font-weight: 600;margin-top:5px">Hi,你好</span>
                        <div style="font-size: 12px;margin-top:5px">欢迎来到迈瑞尔</div>
                      </div>
                    </div>
                    <div style="display: flex;justify-content: space-between;margin-top:15px" v-if="istoken == ''">
                      <el-button type="primary" style="background: #0066BA;" round @click="goRegister">注册</el-button>
                      <el-button type="success" round @click="goLogin">登录</el-button>
                    </div>
                    <div v-else style="margin-top:30px">
                        <div style="display: flex;justify-content: space-between;font-size: 12px">
                          <a style="cursor: pointer;display: flex;flex-direction: column;align-items: center;color:#0066BA;font-weight: 600;" href="/profileInfo">
                            <img style="width:22px;height:22px;margin-bottom:5px" src="https://www.meryer.com/resource/images/i_service.png">
                            <span>个人中心</span>
                          </a>
                          <a style="cursor: pointer;display: flex;flex-direction: column;align-items: center;color:#0066BA;font-weight: 600" href="/cart">
                            <img style="width:22px;height:22px;margin-bottom:5px" src="https://www.meryer.com/resource/images/i_shop.png">
                            <span>购物车</span>
                          </a>
                          <a style="cursor: pointer;display: flex;flex-direction: column;align-items: center;color:#0066BA;font-weight: 600" href="/order_history">
                            <img style="width:22px;height:22px;margin-bottom:5px" src="https://www.meryer.com/resource/images/i_guide.png">
                            <span>订单</span>
                          </a>
                        </div>
                    </div>
                  </el-card>
                  <el-card class="box-card" style="margin-top:10px;height:275px">
                     <div style="font-weight: 600;">技术文章</div>
                     <div v-for="(item,index) in articlesList" :key="index">
                      <span style="font-size: 12px;color:#ccc">{{ item.createtime }}</span><br/>
                      <p style="font-size: 13px;cursor: pointer;margin:5px 0px;font-weight: 600;
                      white-space: nowrap; overflow: hidden; letter-spacing: 1px; text-overflow: ellipsis; 
                      ">
                        <el-tooltip
                          :content="item.subject "
                          placement="top-end"
                        >
                          <span> {{ item.subject }}</span>
                        </el-tooltip>
                      </p>
                      <span style="font-size: 13px;">{{ item.descri }}</span>
                     </div>
                  </el-card>
                </el-col> -->
              </el-row>
          </div> 
          <!-- <div style="width:1200px;margin:auto;margin-top:20px">
            <img style="width:100%" src="https://img-mreyer.oss-cn-shanghai.aliyuncs.com/upload/20250217/20250217104623b684b1513.jpg" alt="">
          </div> -->
          <div style="width: 1200px;margin:30px auto;padding-bottom:10px">
            <div class="product_list">
                <div ref="leftList" :class="{'left_list': isClass,'left_lists': !isClass}">
                  <div
                      style="display: block"
                      :class="isactive == index ? 'left_list_item_active' : 'left_list_item'"
                      ref="leftList"
                      @click="tabsColor(index)"
                      v-for="(item,index) in moleculeList"
                      :key="index">
                        <span>{{ item.name }}</span>
                  </div>
                </div>
            </div>
            <div class="list_container clearfix" style="margin-bottom:16px" :id="'tabs'+index" v-for="(item,index) in moleculeList"
           :key="index">
            <div class="list_title clearfix">
              <span>{{ item.name }}</span>
            </div>
            <div style="display: grid;grid-template-columns: repeat(auto-fill, minmax(200px, 1fr)); gap: 16px;width: 100%;">
                <el-card class="box-card" style="width:200px;cursor: pointer;" @click="goSearch(j)" v-for="(j,i) in item.children" :key="i"> 
                  <div class="item_img" style="display: flex;justify-content: center;align-items: center;">
                    <el-image
                      style="height:150px"
                      :src="j.up_img"
                      fit="scale-down">
                    <template #error>
                        <div class="image-slot">
                          <img src="https://img.x-labseek.com/img/default.jpg" alt="图片加载失败" style="width: 100%">
                        </div>
                    </template>
                  </el-image>
                  </div>
                  <div style="margin-top:6px">
                    <div style="overflow: hidden;width:100%;
                      display: -webkit-box;
                      -webkit-line-clamp: 2;
                      -webkit-box-orient: vertical;
                      overflow: hidden;
                      letter-spacing: 0.5px;
                      line-height: 1;
                      text-overflow: ellipsis;">
                      <el-tooltip
                        :content="j.name"
                        placement="top-end"
                      >
                        <span style="font-size: 13px;color:#000;"> {{j.name}}</span>
                      </el-tooltip>
                    </div>
                  </div> 
              </el-card>
            </div>
            </div>
          </div>
          <!-- <div style="width:1200px;margin:auto;margin-top:20px">
            <img style="width:100%" src="@/assets/bottom_img.jpg" alt="">
          </div> -->
        </div>
  </div>
</template>

<script  setup>
import { Options, Vue } from 'vue-class-component';
import { ref,onMounted,watch,onBeforeUnmount   } from 'vue';
import { useRouter, useRoute } from 'vue-router';
import api from '@/axios/api'
const istoken = ref('')
const router = useRouter()
const route = useRoute()
const selectNumber = ref('')
const category = ref([])
const subCategory = ref([])
const bannerList = ref([])
const isactive = ref('')
const isClass = ref(true)
const articlesList = ref([])
const moleculeList = ref([])
const loadding = ref(false)
const bannerHeight = ref('');
const bannerImgRef = ref(null);

function goClassify(id){
  router.push('/classify/' + id)
}

function selectItem(o) {
  subCategory.value = category.value[o].sub_category
  selectNumber.value = o
}
function  selectItems(){
  selectNumber.value = ''
  subCategory.value = []
  // subCategory.value = category.value.slice(0,11)
}


function goSearch(item){
  if(item.type == 1){
    router.push('/classify/' + item.value)
  }else{
    if(item.product_type && item.product_type == 1){
      const url = `/productDetail/${item.value}`
      window.open(url, '_blank')
    }else if(item.product_type && item.product_type == 2){
      const url = `/swProductDetail/${item.value}`
      window.open(url, '_blank')
    }else if (item.product_type && item.product_type == 3){
      const url = `/hcProductDetail/${item.value}`
      window.open(url, '_blank')
    }  
  }
}

function goLogin(){
  router.push('/login')
}
function goRegister(){
  router.push('/login?type=register')
}
function tabsColor(index) {
  // // 切换选中样式
  // isactive.value = index;
  // // 获取对应iddom
  const tabsId = document.querySelector(`#tabs${index}`);
  // // 判断进行平滑滚动
  if (tabsId) {
    window.scrollTo({
      top: tabsId.offsetTop - 300,
      behavior: "smooth",
    });
  }
}

function scrollHandle(e) {
  let top = e.srcElement.scrollingElement.scrollTop;
  isClass.value = top <= 320;

  // 遍历所有楼层，判断当前滚动到哪个楼层
  moleculeList.value.forEach((_, index) => {
    const tabsId = document.querySelector(`#tabs${index}`);
    if (tabsId) {
      const offsetTop = tabsId.offsetTop - 320;
      const nextTabsId = document.querySelector(`#tabs${index + 1}`);
      const nextOffsetTop = nextTabsId ? nextTabsId.offsetTop - 320 : Infinity;
      if (top >= offsetTop && top < nextOffsetTop) {
        isactive.value = index;
      }
      if(!top >= offsetTop){
        isactive.value = 6
      }
    }
  });
}

function goBanner(item){
  window.open(item.banner_link, "_blank");
}

// 获取图片高度
const screenSize = () => {
  if (bannerImgRef.value && bannerImgRef.value[0]) {
    bannerHeight.value = bannerImgRef.value[0].height;
  }
};

// 监听窗口大小变化
const handleResize = () => {
  if (bannerImgRef.value && bannerImgRef.value[0]) {
    bannerHeight.value = bannerImgRef.value[0].height;
    screenSize();
  }
};

function  handleErrorImage(event) {  
  event.target.src = 'https://img.x-labseek.com/img/default.jpg' // 当图片加载失败时，将其替换为备用图片  
} 


// 组件卸载前移除事件监听
onBeforeUnmount(() => {
  window.removeEventListener('resize', handleResize);
});

watch(() => route.path, (newVal) => {
  istoken.value = localStorage.getItem('MklUserToken') ? localStorage.getItem('MklUserToken') : ''
})

watch(isClass, (newVal) => {
  // 可以在这里添加日志来调试
  console.log('isClass changed to:', newVal);
});
onMounted(()=>{
  screenSize();
  window.addEventListener('resize', handleResize);
  istoken.value = localStorage.getItem('MklUserToken')? localStorage.getItem('MklUserToken') : ''
  api.home.homeApi().then((res)=>{
    if(res.data.code === 200){
      bannerList.value = res.data.data.banner_list
      moleculeList.value = res.data.data.floor_list
      articlesList.value = res.data.data.articles_list.data
    }
  })
  window.addEventListener('scroll', scrollHandle);//绑定页面滚动事件
  api.goods.homeclassifyApi().then((res)=>{
    if(res.data.code === 200){
      category.value = res.data.data.category_nav_tree
    }
  })
})
</script>

<style>
.el-carousel__item:nth-child(2n) {
  background-color: #99a9bf;
}

.el-carousel__item:nth-child(2n + 1) {
  background-color: #d3dce6;
}
</style>

<style  scoped>
.carousel-inner {
  min-width: 1200px;
  margin: auto;
  border-top: 1px solid #bababa;
  padding-top: 1px;
  text-align: center;
}
::v-deep .el-header {
  padding: 0 !important
}
.indexBanner {
  overflow: hidden;
}

.indexBannerImg {
  width: 100%;
  min-width: 999px;
  height: auto;
}
.classify_scroll{
  /* width:1200px; */
  /* margin:auto */
}
::v-deep .is-round{
  padding:8px 21px !important
}
::v-deep .pull-down .el-card__body{
  padding:10px 5px !important;
  height:430px !important
}

::v-deep .box-card .el-card__body{
  padding:8px !important
}
.pull-down{
  position: relative;
  padding:10px 5px;
  background: #fff;
}
.pull-down .pull_item {
  font-size: 12px;
  border-bottom: 1px solid #dddddd;
  cursor: pointer;
  /* width: 160px; */
  margin: auto;
}
 .pull-right {
  width: 1000px;
  min-height: 500px;
  height: 100%;
  overflow-y: auto;
  padding: 10px 0px;
  position: absolute;
  left: 195px;
  top: 0;
  border: 1px solid #0066BA;
  border-radius: 5px;;
  background: #ffffff;
  z-index: 99999;
}
.pull-down .active {
  background: #EBEEF5;
  color: #000;
  border-radius: 5px;
  cursor: pointer;
}

 .pull-right .pull_list {
  line-height: 10px;
  padding: 12px 0;
  font-size: 12px;
  color: #666666;
  display: flex;
}

 .pull-right .pull_list label {
  display: block;
  font-weight: bold;
  width: 130px;
  text-align: right;
  padding-right: 10px;
  font-size: 13px;
}
.pull_list div{
  flex:1
}

 .pull-right .pull_list span {
  display: inline-block;
  padding: 0 10px;
  margin-bottom: 10px;
  border-left: 1px solid #dddddd;
  cursor: pointer;
  font-size: 13px;
}

 .pull-right .pull_list span:hover {
  text-decoration: underline;
  color: rgb(0, 117, 199);
}

 .product_list {
  position: relative;
}

 .product_list .left_list {
   width: 100px;
  height: 420px;
  position: absolute;
  margin-left: -120px;
}

 .product_list .left_lists {
  width: 100px;
  height: 420px;
  position: fixed;
  font-size: 13px;
  top: 300px;
  margin-left: -120px;
}


 .product_list .left_list_item_active {
  background: linear-gradient(100deg, #0096CC, #0066BA );
  min-height: 30px;
  margin-bottom: 5px;
  /* text-align: center; */
  /* line-height: 30px; */
  color: #fff;
  border: 1px solid #0066BA;
  border-radius: 5px;
  cursor: pointer;
  font-size: 13px;
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  padding:0px 8px
}

.list_container{
  display: flex;
  /* justify-content: space-between; */
  flex-wrap: wrap;
}

 .product_list .left_list_item {
  background: #fff ;
  min-height: 30px;
  margin-bottom: 5px;
  /* text-align: center; */
  /* line-height: 30px; */
  color: #0066BA;
  border: 1px solid #0066BA;
  border-radius: 5px;
  cursor: pointer;
  font-size: 13px;
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  padding:0px 8px
}


 .product_list .list_container .list_item .item_img {
  text-align: center;
  box-sizing: border-box;
  margin-bottom: 8px;
  position: relative;
}

 .product_list .list_container .list_item .item_title {
  color: #000;
  /* padding: 0 10px; */
  display: flex;
  /* align-items: center; */
  justify-content: space-between;
}

 .product_list .list_container .list_item .item_des {
  margin: 8px 0px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}


 .product_list .list_container .list_item .item_btm .item_price div:nth-child(1) {
  float: left;
}

 .product_list .list_container .list_item .item_btm .item_price div:nth-child(2) {
  float: right;
  color: red;
}

 .list_container .list_title {
  color: #ffffff;
  height: 40px;
  width:100%;
  line-height: 40px;
  background: linear-gradient(100deg, #0096CC, #0066BA );
  font-size: 14px;
  padding: 0 10px;
  margin-bottom: 20px;
  border-radius:6px ;
}

.product_list .list_container .list_title span:nth-child(2) {
  float: right;
  font-size: 10px;
  cursor: pointer;
}

.product_list .list_container .list_item {
  width: 230px;
  box-shadow: 0 0 5px #888888;
  padding-top: 10px;
  margin-bottom: 20px;
  float: left;
  margin-right: 26px;
  cursor: pointer;
}

.product_list .list_container .list_item:nth-child(4n) {
  float: right;
  margin-right: unset;
}

.product_list .list_container .list_item span {
  display: inline-block;
  padding-right: 10px;
  text-align: right;
  width: 230px;
  box-sizing: border-box;
}

.product_list .list_container .list_item .item_img {
  text-align: center;
  padding: 10px;
  box-sizing: border-box;
}

.product_list .list_container .list_item .item_title {
  height: 40px;
  background: #0066BA;
  color: #ffffff;
  padding: 0 10px;
  display: flex;
  align-items: center;
  line-height: normal;
}

.product_list .list_container .list_item .item_des {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.product_list .list_container .list_item .item_btm {
  padding: 10px;
  line-height: 20px;
}

.product_list .list_container .list_item .item_btm .item_price div:nth-child(1) {
  float: left;
}

.product_list .list_container .list_item .item_btm .item_price div:nth-child(2) {
  float: right;
  color: red;
}

</style>
